// 未读徽章 —— 数字 / 99+ / @ 强提醒变红
//
// 数字 = 0 时返回 null（让 grid 收紧）。

interface UnreadBadgeProps {
  count: number;
  mention?: boolean;
}

export function UnreadBadge({ count, mention }: UnreadBadgeProps) {
  if (count <= 0 && !mention) return null;
  const text = count > 99 ? "99+" : count > 0 ? String(count) : "@";
  const cls = mention ? "unread unread--mention" : "unread";
  return (
    <span className={cls} title={mention ? "有 @我的未读" : "未读"}>
      {text}
    </span>
  );
}
